let refreshInterval = null;

export const startTokenKeepAlive = async (
  getTokenDetails,
  refreshToken
) => {

  // clear existing interval
  stopTokenKeepAlive();

  const refreshIfNeeded = async () => {
    try {
      const { token, isExpired, isExpiring } = getTokenDetails();

      if (isExpired) {
        console.log("Token expired");
        return;
      }

      if (isExpiring) {
        console.log("Refreshing token...");
        await refreshToken(token);
      }
    } catch (err) {
      console.error("Token refresh failed", err);
    }
  };

  // run immediately
  await refreshIfNeeded();

  // then keep checking every 1 minute
  refreshInterval = setInterval(async () => {
    await refreshIfNeeded();
  }, 60 * 1000);
};

export const stopTokenKeepAlive = () => {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
};